import React from "react";

import "./style.scss";
import { Box } from "app/layout/Box/Box";
import { BreadcrumbItem } from "app/breadcrumbs/Breadcrumbs/interfaces";

const labelSpan = (label: string) => <span itemProp="name">{label}</span>;

export interface Props {
    items: BreadcrumbItem[];
    section?: boolean;
}

/**
 * The component renders a breadcrumb navigation based upon the current url path.
 * The path will be split and each part renders its own link in the breadcrumb.
 * The final item can be given as prop.
 */
export const Breadcrumbs = ({ items, section }: Props) => {
    return (
        <Box className={"breadcrumbsBox"} section={section}>
            <ol className={"breadcrumbs"} itemScope itemType="http://schema.org/BreadcrumbList">
                {items.map(({ url, label }, index) => (
                    <li key={index} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                        {url ? (
                            <a itemScope itemProp="item" itemID={url} href={url} itemType="https://schema.org/WebPage">
                                {labelSpan(label)}
                            </a>
                        ) : (
                            labelSpan(label)
                        )}
                        <meta itemProp="position" content={`${index}`} />
                    </li>
                ))}
            </ol>
        </Box>
    );
};
